import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../redux/authSlice";
import { useDispatch } from "react-redux";
import { productionReducer } from "../redux/productionSlice";
import { shareReducer } from "../redux/shareSlice";
import { customersReducer } from "../redux/customersSlice";
import { salesRepReducer } from "../redux/salesRepSlice";
import { formulaSimulatorReducer } from "../redux/formulaSimulatorSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    production: productionReducer,
    share: shareReducer,
    customers: customersReducer,
    salesRep: salesRepReducer,
    formulaSimulator: formulaSimulatorReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore specific action types
        ignoredActions: ["customers/setCustomersDataSource"],
        // Ignore specific field paths
        ignoredPaths: ["customers.customersDataSource", "customers.customersDataSource[].SurchargeStartDate"],
      },
    }),
});

// Type definitions for Redux state and dispatch
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Strongly typed `useDispatch()` for async thunks
export const useAppDispatch: () => AppDispatch = useDispatch;
